
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { dashboardCRUD } from "../../http";
import { yearEnd, yearStart } from "../../functions/dateHelpers";
import FilterDatePicker from "../../components/DatePicker/FilterDatePiecker";
import { Button, Stack } from "@mui/material";
import { Divider } from "antd";
import { LoadingButton } from "@mui/lab";
import {sum} from "../../functions/linqSimulation";
import { roundTo2 } from "../../functions/formatters";
import XLSX from "xlsx-js-style";

const metricGroups = ["Вода", "Атмосфера", "Почва", "Шум", "ЭМП"];
const metricColumns = ["план", "факт", "%", "не соответствие"];

const exportReport = (data, dateRange) => {
    if (!data.length) return;

    const headers = ["№", "Договора с ДСЭК (Регионы)"];
    metricGroups.forEach((name) => headers.push(name, "", "", ""));
    const subHeaders = ["", "", ...metricGroups.flatMap(() => metricColumns)];
    const rows = data.map((item, index) => [
        index + 1,
        item.name,
        ...metricGroups.flatMap((_, metricIndex) => [
            0,
            roundTo2(item[`quantity${metricIndex + 1}`]),
            0,
            roundTo2(item[`inconsistenceQuantity${metricIndex + 1}`]),
        ]),
    ]);
    const totals = ["", "Всего:", ...metricGroups.flatMap((_, metricIndex) => [
        0,
        roundTo2(sum(data, (item) => item[`quantity${metricIndex + 1}`])),
        0,
        roundTo2(sum(data, (item) => item[`inconsistenceQuantity${metricIndex + 1}`])),
    ])];
    const sheet = XLSX.utils.aoa_to_sheet([headers, subHeaders, ...rows, totals]);
    sheet["!merges"] = metricGroups.map((_, index) => ({
        s: { r: 0, c: 2 + index * 4 },
        e: { r: 0, c: 5 + index * 4 },
    }));
    sheet["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } });
    sheet["!merges"].push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } });
    sheet["!cols"] = [{ wch: 6 }, { wch: 34 }, ...metricGroups.flatMap(() => [10, 10, 8, 18])];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "Отчет");
    const start = String(dateRange.operand1 || "").slice(0, 10);
    const end = String(dateRange.operand2 || "").slice(0, 10);
    XLSX.writeFile(workbook, `Мониторинг_объектов_госзаказ_${start}_${end}.xlsx`);
};

const RequestTarificationsQuantityIndices2 = () => {
    const start = yearStart();
    const end = yearEnd();
    
    const [query, setQuery] = useState({
        paging: { skip: 0 },
        filter: {
            researchEndDateTime: {
                operand1: start,
                operand2: end,
                operator: "between"
            }
        }
    });

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchAsync = async () => {
        setLoading(true);        

        const response = await dashboardCRUD.post('requestTarifications/quantity/indices/table2', query);
        setData(response);

        setLoading(false);
    }


    return (
        <DashboardLayout>
            <Stack direction="row" alignItems="center" justifyContent="normal">
                <label style={{minWidth:"360px"}}>Мониторинг объектов контроля и окружающей среды по гос заказу за ПЕРИОД</label>
                <FilterDatePicker key="start" label="от" value={query.filter.researchEndDateTime.operand1} handleFunction={(value) =>
                {
                    if (!value) {
                        return;
                    }
                    query.filter.researchEndDateTime.operand1 = value;
                    setQuery({...query});
                }} style={{width:"250px"}} />
                <FilterDatePicker key="start" label="до" value={query.filter.researchEndDateTime.operand2} handleFunction={(value) =>
                {
                    if (!value) {
                        return;
                    }
                    query.filter.researchEndDateTime.operand2 = value;
                    setQuery({...query});
                }} style={{width:"250px", marginLeft: "10px"}} />
                <LoadingButton loading={loading} style={{marginLeft: "10px"}} onClick={() => fetchAsync()}>
                    Сформировать
                </LoadingButton>                  
                <Button variant="outlined" style={{ marginLeft: "10px" }} onClick={() => exportReport(data, query.filter.researchEndDateTime)} disabled={!data.length}>
                    Скачать Excel
                </Button>
            </Stack>

            <div style={{height: "10px"}}></div>
            
            <table style={{width: "100%"}}>
                <thead className="ant-table-thead">
                    <tr>
                        <th rowSpan={2} className="ant-table-cell">

                        </th>
                        <th rowSpan={2} style={{verticalAlign:"top"}} className="ant-table-cell">
                            Договора c ДСЭК  (Регионы)
                        </th>
                        <th colSpan={4} style={{verticalAlign:"top"}} className="ant-table-cell">
                        Вода
                        </th>
                        <th colSpan={4} className="ant-table-cell">
                        Атмосфера
                        </th>
                        <th colSpan={4} style={{verticalAlign:"top"}} className="ant-table-cell">
                        Почва
                        </th>
                        <th colSpan={4} style={{verticalAlign:"top"}} className="ant-table-cell">
                        Шум                        
                        </th>
                        <th colSpan={4} style={{verticalAlign:"top"}} className="ant-table-cell">
                        ЭМП                        
                        </th>
                    </tr>
                    <tr>                                                
                        <th>
                        план
                        </th>
                        <th>
                        факт
                        </th>
                        <th>
                        %
                        </th>
                        <th>
                        не соответствие
                        </th>
                        <th>
                        план
                        </th>
                        <th>
                        факт
                        </th>
                        <th>
                        %
                        </th>
                        <th>
                        не соответствие
                        </th>
                        <th>
                        план
                        </th>
                        <th>
                        факт
                        </th>
                        <th>
                        %
                        </th>
                        <th>
                        не соответствие
                        </th>
                        <th>
                        план
                        </th>
                        <th>
                        факт
                        </th>
                        <th>
                        %
                        </th>
                        <th>
                        не соответствие
                        </th>
                        <th>
                        план
                        </th>
                        <th>
                        факт
                        </th>
                        <th>
                        %
                        </th>
                        <th>
                        не соответствие
                        </th>
                    </tr>
                </thead>
                <tbody className="ant-table-tbody">
                    {data && data.map((_, index) => {
                     
                        return <tr className="ant-table-row">
                            <td className="ant-table-cell">{index + 1}</td>
                            <td className="ant-table-cell">{_.name}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.quantity1)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.inconsistenceQuantity1)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.quantity2)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.inconsistenceQuantity2)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.quantity3)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.inconsistenceQuantity3)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.quantity4)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.inconsistenceQuantity4)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.quantity5)}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(_.inconsistenceQuantity5)}</td>
                        </tr>})
                    }
                    {data.length > 0 && <tr className="ant-table-row" style={{backgroundColor:"#3cb37188"}}>
                        <td></td>
                        <td>Всего:</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.quantity1))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.inconsistenceQuantity1))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.quantity2))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.inconsistenceQuantity2))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.quantity3))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.inconsistenceQuantity3))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.quantity4))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.inconsistenceQuantity4))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.quantity5))}</td>
                            <td className="ant-table-cell">0</td>
                            <td className="ant-table-cell">{roundTo2(sum(data,_ => _.inconsistenceQuantity5))}</td>
                    </tr>}
                </tbody>
            </table>
        </DashboardLayout>
    )

};

export default RequestTarificationsQuantityIndices2;
